import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from "../../store/auth.store.ts";
import { useAppStore } from '../../store/app.store.ts';

export default function PublicAuthRoute({ children }) {
  const { isAuthenticated, usuario } = useAuthStore((state) => state);
  const navigateTo = useNavigate();
  useEffect(() => {

    const checkIfAuthenticated = () => {
      if (isAuthenticated && !!usuario) {

      
       
        navigateTo('/dashboard');
        

      }
    }
    checkIfAuthenticated();
  }, [isAuthenticated, usuario])


  return children;
}
